import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAccountTypesApiClient } from './i-account-types-api.client';
import { ILookup, IPaginationParameters, IPaginationResponse } from '../../../../core';
import { accountTypesData } from '../data';

@Injectable({
  providedIn: 'root'
})
export class AccountTypesInMemoryApiClient implements IAccountTypesApiClient {
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<ILookup<string>>> {
    return of(accountTypesData.accountTypesResponse);
  }

  getByName(name: string): Observable<ILookup<string>> {
    return of(accountTypesData.accountTypeResponse);
  }
}
